import { SolidButton } from '../Button';
import { H4, P } from '../Text';
import AttentionIcon from 'assets/svgs/AttentionIcon';
import { useTranslation } from 'next-i18next/pages';

import BaseModal from './BaseModal';
import { SearchQueryParams } from 'containers/SearchField';
import useNewSearch from 'hooks/useNewSearch';

interface IExpiredSessionTypeBModalContentProps {
  closeModal: () => void;
  modalOpen: boolean;
  query: SearchQueryParams;
}

const ExpiredSessionTypeBModalContent: React.FC<
  IExpiredSessionTypeBModalContentProps
> = ({ closeModal, modalOpen, query }) => {
  const { t } = useTranslation();
  const { handleNewSearch } = useNewSearch(query);

  return (
    <BaseModal
      closeModal={closeModal}
      modalOpen={modalOpen}
      cancelDisabled
      isExpiredSessionModal>
      <div className="flex flex-col items-center justify-center px-12">
        <AttentionIcon
          className="w-16 h-16"
          exclamationColor="var(--tt-light-gray-purple-line)"
          triangleOutlineColor="var(--tt-light-gray-purple-line)"
        />
        <div className="mt-3 text-center sm:mt-0 sm:text-left">
          <H4 className="!text-lg leading-6 font-medium" centered>
            {t('Expired session')}
          </H4>
          <P className="mt-2" centered>
            {t('Start a new search')}
          </P>
        </div>
        <SolidButton
          className="w-full sm:w-3/4 mt-4"
          onClick={() => {
            closeModal();
            handleNewSearch();
          }}>
          {t('New search')}
        </SolidButton>
      </div>
    </BaseModal>
  );
};

export default ExpiredSessionTypeBModalContent;
